<topo-modal (close)="close()" [backgroundCanClose]="true" [isActive]="showFieldSelect">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="m-4">
    <h5 class="mx-4 my-4">
      {{ 'MANAGEMENT.DATAFEEDS.SELECT-FIELD-LOOKUP' | translate }}
    </h5>
    <div class="dialog-close" (click)="cancelClick()"><i class="icon icon-close-X"></i></div>
  </div>

  <div class="select is-medium m-5">
    <select [(ngModel)]="selectedField">
      <option value="">{{ 'MANAGEMENT.DATAFEEDS.EMPTY-FIELD' | translate }}</option>
      @for (field of lookupTargetSchemaFields; track field.systemName) {
        <option [ngValue]="field?.systemName">
          {{ field.systemName }}
        </option>
      }
    </select>
  </div>
  <div style="padding: 5px">&nbsp;</div>

  <div fxLayout="row" fxLayoutAlign="end" class="m-5">
    <div style="margin-right: 5px">
      <button class="button is-secondary" (click)="cancelClick()">{{ 'FILTERS.CANCEL' | translate }}</button>
    </div>
    <div>
      <button class="button is-primary" (click)="saveClick()">{{ 'FILTERS.SAVE' | translate }}</button>
    </div>
  </div>
</topo-modal>
